module.exports = __webpack_public_path__ + "media/images/arrows/bullet-down-32307acf334611d344ed75b6f1c12965.svg";